import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment/environment';
import type {
	PublicComparatorConfigDTO,
	PublicCompareRequestInput,
	PublicComparisonResponseDTO,
	PublicContractRequestInput,
} from '@libs/dtos/comparator/comparator-public.dto';
import type { BillReadingResponseDTO } from '@libs/dtos/comparator/comparator-reader.dto';
import { Observable } from 'rxjs';

/**
 * The public comparator embedded in the ERIS website (GK-1059). No session:
 * the HTTP interceptor leaves `/public/comparator/` calls alone, and each
 * call that costs something carries a Cloudflare Turnstile token.
 */
@Injectable({ providedIn: 'root' })
export class WebComparatorService {
	private readonly http = inject(HttpClient);
	private readonly baseUrl = `${environment.pathBackend}/public/comparator`;

	config(): Observable<PublicComparatorConfigDTO> {
		return this.http.get<PublicComparatorConfigDTO>(`${this.baseUrl}/config`);
	}

	readBill(file: File, turnstileToken: string): Observable<BillReadingResponseDTO> {
		const body = new FormData();
		body.append('file', file, file.name);
		body.append('turnstileToken', turnstileToken);
		return this.http.post<BillReadingResponseDTO>(`${this.baseUrl}/read`, body);
	}

	compare(request: PublicCompareRequestInput): Observable<PublicComparisonResponseDTO> {
		return this.http.post<PublicComparisonResponseDTO>(`${this.baseUrl}/compare`, request);
	}

	sendRequest(data: PublicContractRequestInput, documents: File[], turnstileToken: string): Observable<{ ok: true }> {
		const body = new FormData();
		body.append('data', JSON.stringify(data));
		for (const file of documents) body.append('documents', file, file.name);
		body.append('turnstileToken', turnstileToken);
		return this.http.post<{ ok: true }>(`${this.baseUrl}/requests`, body);
	}
}
